import React from "react";
import "./BrandsListMobile.scss";
import { desktopImages, mobileImages } from "../../../../images";

const BrandsListMobile = () => {
  const brands = [
    {
      id: "pharma",
      logoClass: "pharma",
      title: "Ciência, precisão e cuidado personalizado.",
      description: "Na Essentia Pharma, unimos inovação farmacêutica, controle rigoroso de processos e tecnologia para transformar prescrições em soluções feitas sob medida para cada pessoa. Nossos laboratórios seguem padrões industriais e nossas tecnologias garantem precisão, eficácia e pureza para os tratamentos.",
      logoDark: desktopImages.EssentiaPharmaDark,
      image: mobileImages.QualidadePharma,
      cta: "Conheça a excelência \n nos medicamentos personalizados",
      link: "https://essentia.com.br/"
    },
    {
      id: "nutrition",
      logoClass: "nutrition",
      title: "Nutrição funcional de alta performance.",
      description: "Na Essential Nutrition, qualidade é o resultado da união entre sabedoria, conhecimento sobre o corpo, tecnologia avançada e os melhores ingredientes do mundo. A partir disso, criamos fórmulas inteligentes, saborosas e de alto valor nutricional. São produtos que trazem ingredientes em sinergia, potencializando benefícios através da combinação dos nutrientes corretos.",
      logoDark: desktopImages.EssentialNutritionDark,
      image: mobileImages.QualidadeNutrition,
      cta: "Explore a perfomance \n da nutrição inteligente",
      link: "https://www.essentialnutrition.com.br/"
    },
    {
      id: "noorskin",
      logoClass: "noorskin",
      title: "Beleza limpa com resultados clínicos.",
      description: "Cleanical é a evolução da beleza limpa, com tecnologia, experiência sensorial e resultados visíveis na pele. Na Noorskin, mais do que escolher ingredientes limpos e seguros, aplicamos testes de alta performance para garantir a eficácia clínica dos nossos produtos. Unimos ciência e segurança para entregar resultados reais, com o mesmo rigor que aplicamos em tudo o que fazemos.",
      logoDark: desktopImages.NoorskinDark,
      image: mobileImages.QualidadeNoorskin,
      image2: desktopImages.Slide3Cremes,
      cta: "Descubra a beleza \n com propósito",
      link: "https://www.noorskin.com.br/"
    },
    {
      id: "technologies",
      logoClass: "technologies",
      title: "A evolução do cuidado.",
      description: "Na Essentia Technologies, desenvolvemos soluções para elevar o cuidado com o ser humano. Com o Easy Health, unimos tecnologias avançadas de inteligência artificial para tornar a gestão clínica mais prática, o acompanhamento mais preciso e o relacionamento entre prescritor e paciente ainda mais humano. É tecnologia feita para quem escolheu cuidar.",
      logoDark: desktopImages.TechnologiesDark,
      image: mobileImages.QualidadeTechnologies,
      cta: "Conheça como a tecnologia \n impulsiona o cuidado",
      link: "https://easy-health.app/landing-page/index.html"
    },
    {
      id: "be-generous",
      logoClass: "be-generous",
      title: "Qualidade que transforma o presente e nutre o futuro.",
      description: "Be Generous é o nosso projeto social que doa suplementos pré-natais para gestantes com maior necessidade nutricional. Os suplementos do Be Generous são produzidos com a mesma qualidade aplicada em todos os nossos produtos e chegam às gestantes em várias partes do Brasil em forma de cuidado, ciência e amor.",
      logoDark: desktopImages.BeGenerousDark,
      image: mobileImages.QualidadeBeGenerous,
      image2: desktopImages.Slide5CapsBeGenerous,
      cta: "Conheça nosso projeto social",
      link: "https://begenerous.com.br/"
    }
  ];

  return (
    <div className="brands-list-mobile">
      <div className="container">
        <div className="brands-list">
          {brands.map((brand, index) => (
            <div key={brand.id} id={brand.id} className={`brand-item brand-item-${brand.id}`}>

              {/* Logo Dark da marca */}
              <div className="brand-logo-section">
                <img
                  src={brand.logoDark}
                  alt={brand.title}
                  className={'brand-logo ' + brand.logoClass}
                />
              </div>

              {/* Imagem principal da marca */}
              <div className="brand-image-section">
                <img
                  src={brand.image}
                  alt={brand.title}
                  className="brand-image"
                />
                {brand.image2 && (
                  <img
                    src={brand.image2}
                    alt={brand.title}
                    className="brand-image-2"
                  />
                )}
              </div>

              {/* Conteúdo da marca */}
              <div className="brand-content">
                <h3 className="brand-title">{brand.title}</h3>
                <p className="brand-description">{brand.description}</p>

                {/* CTA da marca */}
                <a 
                  href={brand.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="brand-cta"
                  dangerouslySetInnerHTML={{
                    __html: brand.cta.replace(/\n/g, '<br>')
                  }}
                />
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandsListMobile;